import { forwardRef, createElement } from 'react';

function IconCashReports(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M13.586 2a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V20.25A1.75 1.75 0 0118.25 22H5.75A1.75 1.75 0 014 20.25V3.75C4 2.784 4.784 2 5.75 2h7.836zM13 3.5H5.75a.25.25 0 00-.243.193L5.5 3.75v16.5a.25.25 0 00.193.243l.057.007h12.5a.25.25 0 00.243-.193l.007-.057V9h-3.75a1.75 1.75 0 01-1.744-1.606L13 7.25V3.5zm-1.143 6.234c.215 0 .434.097.48.36l.009.107v.387c.714.091 1.353.338 1.75.725.301.285.463.602.463.902 0 .355-.28.602-.618.602-.29 0-.51-.102-.779-.333-.456-.435-.843-.607-1.38-.607-.634 0-1.037.36-1.037.811 0 .372.266.62.843.762l.15.033 1.016.21c1.353.263 2.02.934 2.02 2.035 0 1.218-.86 2.076-2.251 2.304l-.193.027v.338c0 .344-.247.468-.49.468-.214 0-.437-.098-.484-.361l-.01-.107v-.327c-.816-.07-1.535-.322-1.981-.736-.301-.274-.473-.585-.473-.908 0-.419.306-.655.688-.655.236 0 .43.075.735.333.478.435 1.005.66 1.547.66.758 0 1.166-.338 1.166-.853 0-.374-.264-.605-.921-.77l-.159-.036-1.01-.22c-1.3-.269-1.955-.967-1.955-2.063 0-1.187.855-2.034 2.199-2.223l.186-.022v-.376c0-.349.247-.467.489-.467zM14.5 4.62v2.63a.25.25 0 00.193.243l.057.007h2.63L14.5 4.621z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var CashReports = /*#__PURE__*/forwardRef(IconCashReports);

export default CashReports;
//# sourceMappingURL=CashReports.js.map
